import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { deco_opt_in } from '../../../../../api'

const offerDeco = (domain, shopUrl, cartToken, callBack) => {
    const fetchDecoWidget = () => {
        const head = document.getElementsByTagName('head')[0]
        const script = document.createElement('script')
        script.type = 'text/javascript'
        script.defer = true
        script.async = true
        script.src = `${domain}/widget/widget.js?shop_url=${shopUrl}&session_id=${cartToken}`
        head.appendChild(script)
    }
    const setupDecoWidget = () => {
        const renderDecoWidget = () => {
            window.removeEventListener('decowidgetready', onDecoReady)
            window.drawDecoWidget(callBack)
        }
        const onDecoReady = () => renderDecoWidget()
        !!window.drawDecoWidget ? renderDecoWidget() : window.addEventListener('decowidgetready', onDecoReady)
    }

    !window.drawDecoWidget && fetchDecoWidget()
    setupDecoWidget()
}

export default props => {
    const { cartToken, shopUrl, checkoutId, onSuccess, onError } = props
    const global = useSelector(state => state.global)
    const { config } = global
    useEffect(() => {
        offerDeco(config.deco?.domain, shopUrl, cartToken, async () => {
            const response = await deco_opt_in(checkoutId)
            if (response?.code === 200 && response?.result) {
                const { result } = response
                if (result) {
                    if (result.success) {
                        onSuccess(result)
                    } else {
                        onError({ message: result.description })
                    }
                }
            } else {
                onError({ message: response?.result || 'Network Error' })
            }
        })
    }, [])

    return <div id="deco-widget" style={{display: 'none'}}>

    </div>
}